import React, { useState, useEffect } from 'react';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import {
    GridComponent, ColumnsDirective, ColumnDirective,
    Inject, Page, Sort, Toolbar
} from "@syncfusion/ej2-react-grids";

const ManageMembers = ({ history }) => {    
    const [customerData, setCustomerData] = useState([]);    
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/Customer/GetAllCustomerGrid`)
            .then((response) => {
                setCustomerData(response.data);
            });
    }, []);    

    const toolbarOptions = [
        "Search"
    ];
    const pageSettingsOptions = {
        pageCount: 3, pageSize: 10, pageSizes: [10, 20, 30, 40, 50]
    };    

    return (
        <div className="int-container">
            <div class="container">
                <div class="form-container-large" style={{ width: "100%" }}>
                    <div class="form-group">
                        <button
                            className="back e-icons e-back e-btn e-flat e-icon-btn"
                            title="Back"
                            onClick={() => history.goBack()}
                        ></button>    
                    </div>
                    <div class="form-group">
                        <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Members</h3>
                    </div>
                    <div id='grdAdmin'>                        
                        <GridComponent dataSource={customerData} allowSorting={true} height='auto'  
                            allowPaging={true} pageSettings={pageSettingsOptions} toolbar={toolbarOptions} >
                            <ColumnsDirective>
                                <ColumnDirective field='customerID' headerText='Customer Id' width='70' textAlign='left' visible={false} />
                                <ColumnDirective field='firstName' headerText='First Name' width='120' textAlign='left' />
                                <ColumnDirective field='lastName' headerText='Last Name' width='120' textAlign='left' />
                                <ColumnDirective field='phone' headerText='Phone' width='130' textAlign='left' />
                                <ColumnDirective field='email' headerText='Email' width='250' textAlign='left' />
                                <ColumnDirective field='mStatus' headerText='Status' width='90' textAlign='left' />
                                {/* <ColumnDirective width="70"
                                    template={({ customerID }) => (
                                        <button
                                            className="e-icons e-edit e-btn e-flat e-icon-btn"
                                            title="Edit"
                                            onClick={() =>
                                                history.push({
                                                    pathname: '/admin/update-pet-profile',
                                                    state: customerID
                                                })
                                            }
                                        ></button>
                                    )}
                                /> */}
                                <ColumnDirective width="80"
                                    template={({ customerID, firstName, lastName }) => (
                                        <button
                                            className="iconadmin"
                                            title="Pets"
                                            onClick={() =>
                                                history.push({
                                                    pathname: '/admin/pets-member',
                                                    state: { cId: customerID,  fName: firstName, lName: lastName }
                                                })
                                            }
                                        >Pets</button>
                                    )}
                                />
                                <ColumnDirective width="80"
                                    template={({ customerID }) => (
                                        <button
                                            className="iconadmin"
                                            title="Calls"
                                            onClick={() =>
                                                history.push({
                                                    pathname: '/admin/calls-member',
                                                    state: customerID
                                                })
                                            }
                                        >Calls</button>
                                    )}
                                />
                                <ColumnDirective width="80"
                                    template={({ customerID }) => (
                                        <button
                                            className="iconadmin"
                                            title="Transactions"
                                            onClick={() =>
                                                history.push({
                                                    pathname: '/admin/transactions-member',
                                                    state: customerID
                                                })
                                            }
                                        >TXN</button>
                                    )}
                                />                                                                                     
                            </ColumnsDirective>
                            <Inject services={[Page, Sort, Toolbar]} />
                        </GridComponent>
                    </div>
                </div>
            </div>
        </div>    
    );
}

export default withRouter(ManageMembers);